import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EffectifDto } from "../../../../dto/GenApi.iNotPaie.Dto/EffectifDto";
import { EntreeSortie } from "../../../../dto/GenApi.iNotPaie.Dto/EntreeSortie";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants from "../../../Controls/EventConstants";
import { ParametresInstance } from "../../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";

@Component({
	components: {
		ModalCardWorkforce: require("../../modals/modalCardWorkforce/modalCardWorkforce.vue.html")
	}
})
export default class CardWorkforce extends Vue {
	public dataReady = false;
	public effectif: EffectifDto = {
		NbrCadres: 0,
		NbrCDD: 0,
		NbrEmployes: 0,
		NbrTechniciens: 0,
		EffectifsParCategorie: [],
		EntreesSorties: []
	};

	public mounted(): void {
		EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
			this.fetchData();
		});

		EventBus.$on(EventConstants.RELOAD_ACCUEIL, () => {
			this.fetchData();
		});
		this.fetchData();
	}

	public fetchData(): void {
		if (ParametresInstance.societeCourante != undefined) {
			ServicesFactoryInstance.AccueilService.getEffectifs(data => {
				this.effectif = data;
				this.dataReady = true;
			});
		}
	}

	public getTitleLine(entreeSortie: EntreeSortie): string {
		return (entreeSortie.IsEntree ? "Entrée" : "Sortie") + " : " + entreeSortie.IntituleSalarie + " - " + entreeSortie.TypeContrat;
    }

    /**
     * Retourne la chaîne de caractère à afficher pour un type d'emploi
     * @param nbr Le nombre de personne
     * @param type Le type d'emploi
     * @returns
     */
    public getNumberAndType(nbr: number, type: string): string {
        return `${nbr} ${type}${nbr > 1 ? "s" : ""}`;
    }

	public afficherDetails(): void {
		$("#modalCardWorkforce").modal("show");
	}
}



// WEBPACK FOOTER //
// ./src/components/home/cards/cardWorkforce/cardWorkforce.ts